import { MainContainer } from "components/shared";
import { SettingLayout } from "layouts/SettingLayout";
import { InnerOptions } from "../InnerOptions";
import { Box } from "components/ui/Box";
import { UpdateForm } from "./UpdateForm";
import { useErrorHandler } from "exceptions/ErrorHandler";
import { useParams } from "react-router-dom";
import { useQuery, useQueryClient } from "react-query";
import { useHubDriver } from "hooks/api";
import { useEffect } from "react";
import { Documents } from "./Documents";


export const HubUpdateDriver: React.FC = () => {
  const { options } = InnerOptions();
  const { id } = useParams<{ id: string }>();
  const { errorHandler } = useErrorHandler();
  const { getDriver, getListDriverDocs } = useHubDriver();
  const queryClient = useQueryClient();

  const { data } = useQuery({
    queryKey: ["getDriver", id],
    queryFn: () => getDriver(id),
    enabled: !!id,
    onError: errorHandler,
  });

  const { data: driverDocs = [] } = useQuery({
    queryKey: ["getListDriverDocs", { driver_id: id }],
    queryFn: () => getListDriverDocs({ driver_id: id }),
    enabled: !!id,
    onError: errorHandler,
  });

  useEffect(() => {
    return () => {
      queryClient.removeQueries(["getDriver", id]);
    };
  }, [id, queryClient]);

  return (
    <MainContainer>
      <SettingLayout options={options}>
        <Box>
          <UpdateForm data={data} />
        </Box>

        <Documents docs={driverDocs} driverId={id} />
      </SettingLayout>
    </MainContainer>
  );
};
